const featuredContentBlockConfig = {
	integrations: {
		imgSpacing: { p: 10 },
		imgWrapperUtility: { display: "flex", justify: "center", align: { items: "center" } },
		imgWrapperSizing: { h: 40 },
	},
	"prism-academy": {
		imgSpacing: { p: 4 },
		imgWrapperUtility: { display: "flex", justify: "center", align: { items: "center" } },
	},
};

export default featuredContentBlockConfig;
